import { AuthMachine, createUseAuth } from '@mogul/shared';

import { apiBase } from './config';

export const authMachine = new AuthMachine({ apiBasePath: apiBase });

authMachine.context.subscribe(context => {
  const { user } = context;
  window.Sentry?.setUser(
    user
      ? {
          id: user.id,
          email: user.email,
          username: user.username,
        }
      : null,
  );
});

export const useAuth = createUseAuth(authMachine);
